import React, { useState } from 'react';
import InputField from '../../input-field';
import Button from '../../button';
import useEditCustomer from '../../../hooks/use-edit-customer';
import CustomerInput from '../../../types/CustomerInput';
import { getAttributeValue } from '../../../lib/attribute';

interface Props {
  customer: any;
}

const AdminUserRetailerForm: React.FC<Props> = ({ customer }) => {
  const [retailerCode, setRetailerCode] = useState(
    getAttributeValue(customer.attributes, 'retailerId')
  );
  const [billingCode, setBillingCode] = useState(
    getAttributeValue(customer.attributes, 'billingCode')
  );
  const [message, setMessage] = useState('');

  const [editCustomer] = useEditCustomer();

  const onClick = async (e) => {
    e.preventDefault();

    const input: CustomerInput = {
      id: customer.id,
      accountId: process.env.SITE!,
      username: customer.username,
      firstName: customer.firstName,
      lastName: customer.lastName,
      address: customer.address,
      attributes: customer.attributes,
    };

    const omit = (key: string, value: string) =>
      key === '__typename' ? undefined : value;
    const address = JSON.parse(JSON.stringify(customer.address), omit);
    let attributes = JSON.parse(JSON.stringify(customer.attributes), omit);

    const tempWslId = attributes.find((a) => a.code === 'billingCode');
    tempWslId.value = `${billingCode}`;

    const tempWslPassword = attributes.find((a) => a.code === 'retailerId');
    tempWslPassword.value = `${retailerCode}`;

    attributes = attributes.filter(
      (a) => a.code !== 'billingCode' || a.code !== 'retailerId'
    );

    input.address = address;
    input.attributes = attributes;

    const {data} = await editCustomer({ input });
    if (data.editCustomer3.error) {
      setMessage(data.editCustomer3.error);
    } else {
      setMessage('Successfully updated retailer details.');
    }
  };

  if (customer.role !== 'retailer') {
    return null;
  }

  return (
    <form>
      <h2>Retailer Details</h2>
      <InputField
        id="retailerCode"
        label="Retailer Code"
        type="text"
        onChange={(e) => setRetailerCode(e.target.value)}
        defaultValue={retailerCode}
      />
      <InputField
        id="billingCode"
        label="Billing Code"
        type="text"
        onChange={(e) => setBillingCode(e.target.value)}
        defaultValue={billingCode}
      />
      <Button text="Save" onClick={onClick} />
      {message && <p>{message}</p>}
    </form>
  );
};

export default AdminUserRetailerForm;
